<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1M12 23C14.2091 23 16 18.0751 16 12C16 5.92487 14.2091 1 12 1M12 23C9.79086 23 8 18.0751 8 12C8 5.92487 9.79086 1 12 1M2 8H22M2 15H22" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>

export default {
  name: 'urlIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
